import { create } from 'zustand';

export type NotesType = {
  id: string;
  category: number;
  access_type: number;
  count: number;
  user_details: UserDetails;
  text: string;
  created_at: string;
  status: number;
  replies?: Reply[];
  media?: Media[];
  lon: number;
  lat: number;
  assignee_details: Assignee[];
  triggeredFromRightPanel?: boolean;
  editMode?: boolean;
};

type UserDetails = {
  id: string;
  email: string;
  full_name: string;
};

export type Reply = {
  id: string;
  text: string;
  created_at: string;
  user_name: string;
  user: string;
};

export type Media = {
  id: string;
  url: string;
  type: number;
  file_name?: string;
};

export type Assignee = {
  id: string;
  email: string;
  full_name: string;
};

interface StoreVariableType {
  notesList: NotesType[];
  selectedNote: NotesType | null;
  selectedNoteToolID: string;
}

interface StoreType extends StoreVariableType {
  updateState: (callback: (arg: StoreType) => any) => void;
  setSelectedNote: (tool_id: string) => void;
  reset: () => void;
}

const INITIAL_STATE: StoreVariableType = {
  selectedNote: null,
  notesList: [],
  selectedNoteToolID: ''
};

const useNotesStore = create<StoreType>(set => ({
  ...INITIAL_STATE,
  updateState: callback => set((state: StoreType) => ({ ...state, ...callback(state) })),
  setSelectedNote: (tool_id: string) =>
    set((state: StoreType) => {
      if (state.selectedNoteToolID === tool_id) return state;

      const { notesList } = state;
      const selectedNote =
        notesList.find(note => {
          const id = note?.id;
          return id === tool_id;
        }) || null;

      return {
        ...state,
        selectedNote,
        selectedNoteToolID: tool_id
      };
    }),
  updateSelectedNote: () =>
    set((state: StoreType) => {
      const noteList = state.notesList;
      const tool_id = state.selectedNoteToolID;
      const selectedNote =
        noteList.find(note => {
          const id = note?.id;
          return id === tool_id;
        }) || null;

      return {
        ...state,
        selectedNote
      };
    }),
  reset: () => set((state: StoreType) => ({ ...state, ...INITIAL_STATE }))
}));

export default useNotesStore;
